module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [(!_vm.isMobile) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer-left col-md-6"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": require("assets/footer-logo.png")
    }
  })]), _c('div', {
    staticClass: "footer-right col-md-6"
  }, [_c('ul', [_c('li', [_vm._v("WirForce 2017 Presented By 4Gamers.")]), _c('li', [_vm._v("Copyright © 2017 4Gamers Taiwan. All Rights Reserved.")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-left col-md-6"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": require("assets/footer-logo.png")
    }
  }), _c('ul', [_c('li', [_vm._v("WirForce 2017 Presented By 4Gamers.")]), _c('li', [_vm._v("Copyright © 2017 4Gamers Taiwan. All Rights Reserved.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e12ff262"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/vueFooter.vue
// module id = 587
// module chunks = 1